import { SeoLink as GqlCmsLink } from '../../graphql.generated';
import { Document } from '@contentful/rich-text-types';
import { SeoLink, SeoLinkPictograms, isValidPictogram } from '../cms-seo.types';

/* This function takes an SeoLink as defined by GraphQL
 * and normalises it to a type-safe format CmsSeoLink needs
 */
export function seoLinkCheck(seoLink: GqlCmsLink): SeoLink {
    const typeSafePictogram: SeoLinkPictograms = isValidPictogram(
        seoLink.pictogram
    )
        ? seoLink.pictogram
        : 'City - Yellow';

    return {
        title: seoLink.title,
        subtitle: seoLink?.subtitle ?? undefined,
        pictogram: typeSafePictogram,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        links: seoLink.links as Document
    };
}
